module.exports = __webpack_public_path__ + "media/images/icons/filled/up-square-ed4b1a013bfe490648798b79458dc2c9.svg";